<template>
  <div ref="container">
    <a-modal v-if="visible" :title="title" width="95%" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:50px;height: 90%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">关闭</a-button>
        <a-button v-if="current > 0" style="margin-left: 8px" @click="prev">
          上一步
        </a-button>
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">
          下一步
        </a-button>
        <a-button
          v-if="current == steps.length - 1"
          type="primary"
          @click="handleOk"
        >
          完成
        </a-button>

      </template>
      <a-spin :spinning="confirmLoading">

        <a-steps :current="current" style="margin-bottom: 10px;width: 40%;margin-left: 30%">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div class="steps-content">
          <a-form-model ref="form1" :model="form" :rules="rules1" v-show="current == 0">
            <a-card class="card" >
            <span class="title">产品标识信息</span>
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/2" v-show="false">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最小销售单元产品标识">
                  <a-input style="width:90%;" placeholder="系统自动生成" disabled v-model="form.productDi" />
                  <a-tooltip placement="right" title="某种规格型号医疗器械的最小销售单元上的UDI-DI">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品标识体系编码名称" name="codeSystem" prop="codeSystem">
                  <!-- <a-select style="width:90%;" showSearch optionFilterProp="children" :disabled="(form.id ==null)? false : true" v-model="form.codeSystem" @change="codeSysChange" mode="multiple" v-show="title === '新增产品DI' ? true : false">
                    <a-select-option v-for="(item,index) in matype" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select> -->

                  <a-checkbox-group v-show="title === '新增产品DI' ? true : false" v-model="form.codeSystem" @change="onColChange">
                    <a-checkbox :value="item.value" v-for="item in matype" :key="item.value"  >
                      {{item.label}}
                    </a-checkbox>
                  </a-checkbox-group>
                  <span v-show="title === '新增产品DI' ? false : true" style="margin-right: 20px;">
                    <a v-if="form.codeSystem.indexOf('1') !== -1" style="margin-right: 20px;">MA码(IDcode)</a>
                    <a v-if="form.codeSystem.indexOf('2') !== -1">GS1</a>
                  </span>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/2" v-show="( form.codeSystem[0] === '2' || form.codeSystem[0] === '1')? true : false">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标识载体" name="identificationCarrier" prop="identificationCarrier">
                  <a-select style="width:90%;" showSearch optionFilterProp="children" disabled="disabled" v-model="form.identificationCarrier" mode="multiple" aria-readonly="true" v-show="false">
                    <a-select-option v-for="(item,index) in identificationCarrierTypes" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                  <span v-if="this.form.codeSystem.indexOf('1') !== -1">
                    二维码
                  </span>
                  <span  v-if="this.form.codeSystem.indexOf('2') !== -1">
                    一维码
                  </span>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发布时间" name="releaseTime" prop="releaseTime">
                  <j-date v-model="form.releaseTime" dateFormat="YYYY-MM-DD HH:mm:ss" placeholder="请输入选择发布时间" :show-time="true" />
                  <a-tooltip placement="right" title="产品标识在医疗器械唯一标识数据库上对外发布的日期(由企业自行指定)">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2" >
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最小销售单元中使用的数量" name="minSaleNumber" prop="minSaleNumber">
                  <a-input v-model="form.minSaleNumber" onkeyup="value=value.replace(/[^\d{1,}\d{1,}|\d{1,}]/g,'')"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2" v-if="this.form.minSaleNumber > 1 && this.form.codeSystem.indexOf('1') !== -1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="MA码使用单位产品标识" name="maUseIdentification" prop="maUseIdentification">
                  <a-input v-model="form.maUseIdentification" placeholder="请输入MA码使用单位产品标识"  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2" v-if="this.form.minSaleNumber > 1 && this.form.codeSystem.indexOf('2') !== -1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="GS1码使用单位产品标识" name="gs1UseIdentification" prop="gs1UseIdentification">
                  <a-input v-model="form.gs1UseIdentification" placeholder="请输入GS1码使用单位产品标识"  />
                </a-form-model-item>
              </a-col>

              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否与最小销售单元产品标识一致" name="identificationCarrier" prop="identificationCarrier">

                  <a-radio-group v-model:value="form.isSameIdentification">
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                  </a-radio-group>
                  <a-tooltip placement="right" title="医疗器械本体产品标识与最小销售单元产品标识是否一致">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否与注册/备案产品标识一致" name="identificationCarrier" prop="identificationCarrier">

                  <a-radio-group v-model:value="form.isSameRegistered">
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                  </a-radio-group>
                  <a-tooltip placement="right" title="注册/备案产品标识与最小销售单元产品标识是否一致">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否有本体标识" name="identificationCarrier" prop="identificationCarrier">

                  <a-radio-group v-model:value="form.isHaveBody">
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                  </a-radio-group>
                  <a-tooltip placement="right" title="是否有医疗器械本体直接标识">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- <a-row class="form-row" :gutter="24" v-show="(this.form.codeSystem.includes('2') && form.id ==null)? true : false"> -->
            <a-row class="form-row" :gutter="24" v-if="this.form.codeSystem.indexOf('2') !== -1">

              <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="GS1产品编码" name="gs1Code" prop="gs1Code">
                  <a-input style="width:90%" :disabled="(form.codeSystem.includes('2') && form.id ==null)? false : true" placeholder="请输入GS1产品编码" v-model="form.gs1Code" />
                  <a-tooltip placement="right" title="产品标识体系编码名称选择GS1时，必填">
                    <a-icon type="question-circle" style="margin-left:10px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-card>
          </a-form-model>

          <a-form-model ref="form2" :model="form" :rules="rules2" v-show="current == 1">
            <a-card class="card" style="margin-top:30px;" >
              <span class="title">产品基本信息</span>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称/通用名称" name="productName" prop="productName">
                    <a-input style="width:90%" placeholder="请输入产品名称/通用名称" v-model="form.productName" />
                    <a-tooltip placement="right" title="医疗器械注册证或备案凭证上载明的产品名称/通用名称">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品名称" name="goodsName" prop="goodsName">
                    <a-input style="width:90%" placeholder="请输入商品名称" v-model="form.goodsName" />
                    <a-tooltip placement="right" title="由医疗器械注册人/备案人确定的医疗器械商品名称">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" name="specificationModel" prop="specificationModel">
                    <a-input style="width:90%" placeholder="请输入规格型号" v-model="form.specificationModel" />
                    <a-tooltip placement="right" title="医疗器械注册证或备案凭证上确定的规格型号，且应与最小销售单元产品标识一一对应；当医疗器械是独立软件时，填写版本号">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="器械是否为包类产品" name="isPackage" prop="isPackage">
                    <a-radio-group v-model:value="form.isPackage">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="包括手术包、体外诊断试剂套装、组套类等情况">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品描述" name="productDetails" prop="productDetails">
                    <a-textarea style="width:90%" :rows="3" placeholder="请输入产品描述" v-model="form.productDetails" />
                    <a-tooltip placement="right" title="包括产品注册证或备案凭证上附页相关描述以及其他必需的产品描述，应与最小销售单元产品标识一一对应；当医疗器械为包类/组套类产品（经批准的）时，还应列明所有组件的产品名称和数量；当医疗器械附带软件时，须列明软件版本号">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品类编码" name="productNo" prop="productNo">
                    <a-input style="width:90%" :disabled="title=='编辑产品DI'" placeholder="请输入品类编码" v-model="form.productNo" v-show="title === '新增产品DI' ? true : false"/>
                    <span v-show="title === '新增产品DI' ? false : true">{{ form.productNo }}</span>
                    <a-tooltip placement="right" title="请输入6-10位品类编码，仅支持字母、数字、部分字符">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原器械目录代码">
                    <a-input style="width:90%;" placeholder="请输入原器械目录代码" v-model="form.originalCode" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="器械类别" name="deviceCategory" prop="deviceCategory">
                    <a-radio-group v-model:value="form.deviceCategory" @change="onDeviceCateChange">
                      <a-radio :value="1">器械</a-radio>
                      <a-radio :value="2">体外诊断试剂</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械类别">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row">
                <a-col :span="24">
                  <a-form-model-item :labelCol="{xs: { span: 1 },sm: { span: 4 }}" :wrapperCol="wrapperCol" label="分类编码" name="categoryValue2" prop="categoryValue2">
                    <a-row :gutter="24">
                      <a-col :span="7">
                        <a-form-model-item prop="categoryValue1" :rules="{required:categoryFirst.length>0,message: '请选择分类编码'}">
                          <a-select style="width:300px" v-model="form.categoryValue1" @change="onCateFirstChange">
                            <a-select-option v-for="item in categoryFirst" :key="item.id" :value="item.categoryValue">
                              {{item.categoryName}}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="7" v-show="form.categoryValue1">
                        <a-form-model-item prop="categoryValue2" :rules="{required:categorySecond.length>0,message: '请选择分类编码'}">
                          <a-select style="width:300px" v-model="form.categoryValue2" @change="onCateSecondChange">
                            <a-select-option v-for="item in categorySecond" :key="item.id" :value="item.categoryValue">
                              {{item.categoryName}}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="7" v-show="form.deviceCategory == 1 && form.categoryValue2" >
                        <a-form-model-item prop="categoryValue" :rules="{required:categoryThird.length>0,message: '请选择分类编码'}">
                          <a-select style="width:300px" v-model="form.categoryValue">
                            <a-select-option v-for="item in categoryThird" :key="item.id" :value="item.categoryValue">
                              {{item.categoryName}}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                      <a-tooltip placement="right" title="国家医疗器械监管部门发布的医疗器械类别编码">
                        <a-icon type="question-circle" style="margin-left:30px" />
                      </a-tooltip>
                    </a-row>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="磁共振(MR)安全相关信息" name="mrSafetyInfo" prop="mrSafetyInfo">
                    <a-select style="width:90%;" placeholder="请选择申报状态" showSearch optionFilterProp="children" v-model="form.mrSafetyInfo">
                      <a-select-option v-for="(item,index) in safeList" :key="index" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                    <a-tooltip placement="right" title="产品说明书或标签中载明的与磁共振（MR）相关安全兼容状态">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别" name="productType" prop="productType">
                    <a-radio-group v-model:value="form.productType">
                      <a-radio :value="0">耗材</a-radio>
                      <a-radio :value="1">设备</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="产品类别：耗材或设备">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2" v-show="form.isDisposable ? false : true">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最大重复使用次数">
                    <a-input-number style="width:90%" :disabled="form.isDisposable  ? true :false " v-model="form.maxReuseNumber" />
                    <a-tooltip placement="right" title="当产品说明书或标签上载明最大重复使用次数时必选，标签或说明书有明确最大重复使用次数时请按标签或说明书填写（MR）相关安全兼容状态">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否标记为一次性使用" name="isDisposable" prop="isDisposable">
                    <a-radio-group v-model:value="form.isDisposable">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="一次性使用是指在医疗器械说明书或标签已注明“一次性使用”字样或者符号的情形">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用前是否需要灭菌" name="isSterilization" prop="isSterilization">
                    <a-radio-group v-model:value="form.isSterilization" @change="onTypeChange">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械使用前是否需要进行灭菌">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="灭菌方式" name="sterilizationMethod" prop="sterilizationMethod">
                    <a-input style="width:90%" :disabled="form.isSterilization ? false : true" placeholder="请输入灭菌方式" v-model="form.sterilizationMethod" />
                    <a-tooltip placement="right" title="医疗器械的灭菌方式，使用前需要进行灭菌的情况下，必填">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否为无菌包装" name="isAseptic" prop="isAseptic">
                    <a-radio-group v-model:value="form.isAseptic">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械是否为出厂前已灭菌的产品">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="其它信息的网址链接">
                    <a-input style="width:90%" placeholder="请输入其它信息的网址链接" v-model="form.otherUrl" />
                    <a-tooltip placement="right" title="提供医疗器械其他信息的网址链接">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册证编号/备案凭证编号" name="registerNo">
                    <span v-show="form.registerNo" style="margin-right: 40px;">{{ form.registerNo }}</span>
                    <a-input disabled style="width:70%" placeholder="请输入注册证编号/备案凭证编号" v-model="form.registerNo" v-show="false"/>
                    <a-button @click="gozhuce" type="primary">选择</a-button>
                    <a-tooltip placement="right" title="医疗器械注册证载明的注册证编号或备案凭证载明的备案凭证编号">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="医疗器械注册人/备案人英文名称">
                    <a-input style="width:90%" placeholder="请输入医疗器械注册人/备案人英文名称" v-model="form.registerNameEn" />
                    <a-tooltip placement="right" title="医疗器械注册证/备案凭证载明的注册人/备案人英文名称">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2" v-show="form.registerNo ? true : false">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="医疗器械注册人/备案人名称" name="registerName">
                    <span v-show="form.registerName" style="margin-right: 40px;">{{ form.registerName }}</span>
                    <a-input disabled style="width:90%" placeholder="请输入医疗器械注册人/备案人名称" v-model="form.registerName" v-show="false"/>
                    <a-tooltip placement="right" title="医疗器械注册证/备案凭证载明的注册人/备案人">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="医保编码">
                    <a-input style="width:90%" placeholder="请输入医保编码" v-model="form.medicalCode" />
                    <a-tooltip placement="right" title="填写27位的国家医保耗材分类编码，若存在多个医保耗材分类编码，以英文逗号,分隔医保耗材分类编码">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form-model>

          <a-form-model ref="form3" :model="form" :rules="rules3" v-show="current == 2">
            <a-card class="card" style="margin-top:30px;" >
              <span class="title">生产标识信息</span>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产标识是否包含批号" name="isBatchNumber" prop="isBatchNumber">
                    <a-radio-group v-model:value="form.isBatchNumber">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械生产标识是否包含批号">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产标识是否包含序列号" name="isSerialNumber" prop="isSerialNumber">
                    <a-radio-group v-model:value="form.isSerialNumber">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械生产标识是否包含序列号">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产标识是否包含生产日期" name="isStartDate" prop="isStartDate">
                    <a-radio-group v-model:value="form.isStartDate">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械生产标识是否包含生产日期">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/2">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产标识是否包含失效日期" name="isEndDate" prop="isEndDate">
                    <a-radio-group v-model:value="form.isEndDate">
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                    <a-tooltip placement="right" title="医疗器械生产标识是否包含失效日期">
                      <a-icon type="question-circle" style="margin-left:10px" />
                    </a-tooltip>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
            <a-card class="card" style="margin-top:30px;" >
              <div class="title-box">
                <span class="title">储存或操作信息</span>
                <a-button @click="addinfo" class="btn" type="primary">添加</a-button>
              </div>
              <a-row class="form-row" :gutter="24" v-for="(it,idx) in form.productStoreList" :key="idx">
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="储存或操作条件">
                    <a-input placeholder="请输入储存或操作条件" v-model="it.storeConditions" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="值范围">
                    <a-input style="width:100px" v-model="it.minValue" />~
                    <a-input style="width:100px" v-model="it.maxValue" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计量单位">
                    <a-input placeholder="请输入计量单位" v-model="it.unit" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-button v-if="it.isdel" @click="delinfo(idx)" type="primary">移除</a-button>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :labelCol="{ xs: { span: 12 },sm: { span: 3 }}" :wrapperCol="wrapperCol" label="特殊储存或操作条件">
                    <a-textarea :rows="3" placeholder="请输入特殊储存或操作条件" v-model="form.specialConditions" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
            <a-card class="card" style="margin-top:30px;" >
              <div class="title-box">
                <span class="title">临床使用尺寸信息</span>
                <a-button @click="addinfo1" class="btn" type="primary">添加</a-button>
              </div>

              <a-row class="form-row" :gutter="24" v-for="(it,idx) in form.productSizesList" :key="idx">
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="临床使用尺寸类型">
                    <a-input placeholder="请输入临床使用尺寸类型" v-model="it.sizeType" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="尺寸值">
                    <a-input-number style="width:100%" :min="1" placeholder="请输入尺寸值" v-model="it.sizeValue" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="尺寸单位">
                    <a-input placeholder="请输入尺寸单位" v-model="it.unit" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24/4">
                  <a-button v-if="it.isdel" @click="delinfo1(idx)" type="primary">移除</a-button>
                </a-col>
              </a-row>
              <a-row class="form-row" :gutter="24">
                <a-col :span="24">
                  <a-form-model-item :labelCol="{ xs: { span: 12 },sm: { span: 2 }}" :wrapperCol="wrapperCol" label="特殊尺寸说明">
                    <a-textarea :rows="3" placeholder="请输入特殊尺寸说明" v-model="form.specialSize" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form-model>
        </div>
<!--          <a-pagination class="page" v-model="page" :total="30" show-less-items @change="changePages(form)"/>-->
      </a-spin>
    </a-modal>
    <regModel ref="regModelref" @change="costPlannedAmountChange($event)"></regModel>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { updateProductDi, checkSupplier, createProductDi, udiCategory, Didetail, listCertificate } from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import JDate from '@/components/jeecg/JDate'
import regModel from './regModel.vue'
export default {
  name: 'CustomerModal',
  mixins: [mixinDevice],
  components: {
    JDate,
    regModel,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: '第一步',
          content: '第一步',
        },
        {
          title: '第二步',
          content: '第二步',
        },
        {
          title: '第三步',
          content: '第三步',
        },
      ],
      safeList: [
        {
          // 最大安全信息0：安全；1：条件安全；2：不安全；3：说明书或标签上面不包含MR安全性信息
          label: '安全',
          value: '0',
        },
        {
          label: '条件安全',
          value: '1',
        },
        {
          label: '不安全',
          value: '2',
        },
        {
          label: '说明书或标签上面不包含MR安全性信息',
          value: '3',
        },
      ],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ],
      identificationCarrierTypes: [
        {
          label: '一维码',
          value: '1',
        },
        {
          label: '二维码',
          value: '2',
        }
      ],

      title: '操作',
      visible: false,
      model: {},
      form: {
        id:'',
        productDi: '', //最小销售单元产品标识
        codeSystem: ['1'], //产品标识体系编码名称
        releaseTime: '', //发布时间
        minSaleNumber: '1', //最小销售单元中使用的数量
        maUseIdentification: '',//MA使用单位产品标识
        gs1UseIdentification: '',//GS1使用单位产品标识
        gs1Code: '', //GS1产品编码
        isSameIdentification: true, //是否与最小销售单元产品标识一致
        isSameRegistered: true, //是否与注册/备案产品标识一致
        isHaveBody: false, //是否有本体标识
        identificationCarrier: ['2'], //标识载体
        specialConditions: '', //特殊储存或操作条件
        specialSize: '', //特殊尺寸说明
        productName: '', //产品名称/通用名称
        goodsName: '', //商品名称
        specificationModel: '', //规格型号
        isPackage: true, //器械是否为包类产品
        productDetails: '', //产品描述
        productNo: '', //品类编码
        originalCode: '', //原器械目录代码
        deviceCategory: '1', //器械类别
        mrSafetyInfo: '', //磁共振(MR)安全相关信息
        productType: '0', //产品类别
        maxReuseNumber: '', //最大重复使用次数
        isDisposable: true, //是否标记为一次性使用
        isSterilization: true, //使用前是否需要灭菌
        sterilizationMethod: undefined, //灭菌方式
        isAseptic: true, //是否为无菌包装
        otherUrl: '', //其它信息的网址链接
        registerNameEn: '', //医疗器械注册人/备案人英文名称
        registerName: '', //医疗器械注册人/备案人名称
        medicalCode: '', //医保编码
        registerNo: '', //注册证编号/备案凭证编号
        categoryCode: '',
        categoryValue1: '',
        categoryValue2: "",
        categoryValue: "",
        packageSpecification: 0, //写死
        isBatchNumber: true, //含批号
        isSerialNumber: true, //序列号
        isStartDate: true, //生产日期
        isEndDate: true, //失效日期
        productStoreList: [{ storeConditions: '', minValue: '', maxValue: '', unit: '', isdel: false }], //储存或操作信息
        productSizesList: [{ sizeType: '', sizeValue: '', unit: '', isdel: false }], //临床使用尺寸信息
      },
      value: 1,
      value1: 1,
      isReadOnly: false,
      checked: true,
      checked1: false,
      labelCol: {
        xs: { span: 10 },
        sm: { span: 8 },
      },
      labelColfel: {
        xs: { span: 6 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      // form: this.$form.createForm(this),
      zclist: [],
      zcNolist: [],
      categoryFirst: [],
      categorySecond: [],
      categoryThird: [],
      rules1:{
        gs1Code: [{ required: false, message: '' }],
        codeSystem: [{ required: true, message: '请选择产品标识体系编码名称!' }],
        releaseTime: [{ required: true, message: '请选择发布时间!' }],
        minSaleNumber: [{ required: true, message: '最小销售单元中使用的数量不能为空!' }],
        identificationCarrier: [{ required: true, message: '请选择标识载体!' }],
      },
      rules2:{
        productName: [{ required: true, message: '产品名称/通用名称不能为空!' }],
        specificationModel: [{ required: true, message: '规格型号不能为空!' }],
        productDetails: [{ required: true, message: '产品描述不能为空!' }],
        productNo: [{ required: true, message: '品类编码不能为空!' }],
        deviceCategory: [{ required: true, message: '请选择器械类别!' }],
        categoryValue2: [{ required: true, message: '请输入分类编码!' }],
        mrSafetyInfo: [{ required: true, message: '请选择磁共振(MR)安全相关信息!' }],
        isDisposable: [{ required: true, message: '请选择是否标记为一次性使用!' }],
        isSterilization: [{ required: true, message: '请选择使用前是否需要灭菌!' }],
        sterilizationMethod: [{ required: true, message: '灭菌方式不能为空!' }],
        registerNo: [{ required: true, message: '请输入注册证编号/备案凭证编号!' }],
        registerName: [{ required: true, message: '请输入医疗器械注册人/备案人名称!' }],
        productType: [{ required: true, message: '请选择产品类别!' }],
        isAseptic: [{ required: true, message: '请选择是否为无菌包装!' }],
        isPackage: [{ required: true, message: '请选择器械是否为包类产品!' }],
      },
      rules3:{
        isBatchNumber: [{ required: true, message: '请选择生产标识是否包含批号!' }],
        isSerialNumber: [{ required: true, message: '请选择生产标识是否包含序列号!' }],
        isStartDate: [{ required: true, message: '请选择生产标识是否包含生产日期!' }],
        isEndDate: [{ required: true, message: '请选择生产标识是否包含失效日期!' }],
      },
      rules: {
        // categoryValue1: [{ required: true, message: '请选择分类编码!' }],
        // categoryValue2: [{ required: true, message: '请选择分类编码!' }],
        // categoryValue: [{ required: true, message: '请选择分类编码!' }],
      },
      /* 新增产品DI - 分页 */
      page: 1
    }
  },
  created() {
    this.onDeviceCateChange()
  },
  methods: {
    onColChange (event, optionValue) {


      // 如果复选框被选中
      // if (event.target.checked) {
      //   // 添加值到数组中
      //   if(this.form.codeSystem.indexOf(optionValue) == -1){
      //     this.form.codeSystem.push(optionValue);
      //   }
      // } else {
      //   // 如果复选框被取消选中，从数组中移除值
      //   const index = this.form.codeSystem.indexOf(optionValue);
      //   if (index !== -1) {
      //     this.form.codeSystem.splice(index, 1);
      //   }
      // }

      if(this.form.codeSystem.indexOf('2') !== -1){
        this.rules1.gs1Code = [{ required: true, message: 'GS1产品编码不能为空!' },{validator:this.validateGs1code}]
      }else{
        this.rules1.gs1Code = [{ required: false, message: '' }]
        this.form.gs1Code = ''
      }
    },
    validateGs1code(rule, value, callback){
      if (value && (value.length < 13 || value.length > 14)) {
        callback('GS1产品编码长度不正确');
      } else {
        callback();
      }
    },
    getCheckBoxValue(e){
      console.log(e)
    },
    costPlannedAmountChange(value) {
      console.log(value, 'value---')
      this.form.registerNo = value.registerNoList.join(',')
      this.form.registerName = value.registerNameList.join(',')
    },
    gozhuce() {
      this.$refs.regModelref.add()
    },
    gozhucelist() {
      this.$router.push(`/UDIadmin/registeradmin`)
    },
    codeSysChange(value) {
      console.log(value, 'val');
      this.form.identificationCarrier=[];
      let ifErweimaMust=false;
      for (let i=0; i<value.length;i++){
        let bb=value[i];
        if (bb==='1'){
          this.form.identificationCarrier.push('2');
        }else {
          this.form.identificationCarrier.push('1');
          ifErweimaMust=true;
        }
      }
      if (!ifErweimaMust) {
        this.rules1.gs1Code = [{ required: false, message: '' }]
        this.form.gs1Code = ''
      } else {
        console.log('GS1产品编码不能为空')
        this.rules1.gs1Code = [{ required: true, message: 'GS1产品编码不能为空!' }]
      }
    },
    // 使用前是否需要灭菌
    onTypeChange(e) {
      console.log(e.target.value, 'val')
      if (!e.target.value) {
        this.rules2.sterilizationMethod = [{ required: false, message: '' }]
        this.form.sterilizationMethod = undefined
        this.$refs['form2'].clearValidate()
      } else {
        this.rules2.sterilizationMethod = [{ required: true, message: '灭菌方式不能为空!' }]
      }
    },
    onDeviceCateChange(val) {
      // console.log(val, 'change')
      this.categoryFirst = []
      this.form.categoryValue1 = ''
      this.categorySecond = []
      this.form.categoryValue2 = ''
      this.categoryThird = []
      this.form.categoryValue = ''
      this.getCategory(1)
      this.rules2.categoryValue = [{ required: false, message: '' }]
    },
    getCategory(level, parentValue) {
      console.log(this.form.deviceCategory, level, parentValue)
      udiCategory({
        type: this.form.deviceCategory,
        level: level,
        parentValue: parentValue ? parentValue : null,
      })
        .then((res) => {
          // console.log(res.data,'一级分类')
          if (level == 1) {
            this.categoryFirst = res.data
            // console.log(this.categoryFirst, '一级分类==')
          } else if (level == 2) {
            this.categorySecond = res.data

            // console.log(this.categorySecond, '二级分类==')
          } else if (level == 3 && this.form.deviceCategory == 1) {
            this.categoryThird = res.data
            // console.log(this.categoryThird, '三级分类==')
          }
        })
        .catch(() => {})
    },
    onCateFirstChange(val) {
      console.log(val, '选中一级类别')
      this.getCategory(2, val)
      this.categorySecond = []
      this.$set(this.form,'categoryValue2','')
      this.categoryThird = []
      this.form.categoryValue = ''
      console.log(this.form.categoryValue1, '分类编码111')
    },
    onCateSecondChange(val) {
      console.log(val, '选中二级类别')
      this.getCategory(3, val)
      this.categoryThird = []
      this.form.categoryValue = undefined
    },
    addinfo() {
      this.form.productStoreList.push({
        storeConditions: '',
        minValue: '',
        maxValue: '',
        unit: '',
        isdel: true,
      })
    },
    addinfo1() {
      this.form.productSizesList.push({
        sizeType: '',
        sizeValue: '',
        unit: '',
        isdel: true,
      })
    },
    delinfo(idx) {
      this.form.productStoreList.splice(idx, 1)
    },
    delinfo1(idx) {
      this.form.productSizesList.splice(idx, 1)
    },
    add(holdData) {
      this.edit({})
    },
    async getzhucelist() {
      const res = await listCertificate()
      console.log(res, 'res----------')
      if (res.errno == 200 && res.errmsg == '成功') {
        this.zclist = res.data.list
      } else {
        this.$message.error(res.data || res.errmsg)
      }
    },
    edit(record) {
      this.current = 0
      console.log('这里表单有没有', this.form)
      console.log(record, 'record')
      console.log(this.$store.getters.userInfo.id, '用户信息')
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      this.visible = true
      this.$nextTick(async () => {
        if (record.id) {
          this.confirmLoading = true
          const res = await Didetail({ id: record.id,codeSystem:record.codeSystem })
          console.log(res, 'res-----')
          if (res.errno == 200 && res.errmsg === '成功') {
            console.log('他的数据是什么？？？', res.data)
            this.form = res.data
            this.form.releaseTime = res.data.releaseTime.replace('.0', '')
            if (res.data.productSizesList.length == 0) {
              this.form.productSizesList = [{ sizeType: '', sizeValue: '', unit: '', isdel: false }]
            }
            if (res.data.productStoreList.length == 0) {
              this.form.productStoreList = [{ storeConditions: '', minValue: '', maxValue: '', unit: '', isdel: false }]
            }
            this.form.productSizesList.forEach((it, index) => {
              if (index > 0) {
                it.isdel = true
              }
            })
            this.form.productStoreList.forEach((it, index) => {
              if (index > 0) {
                it.isdel = true
              }
            })
            let codeList = res.data.categoryBox.split('|')
            if (codeList.length > 3) {
              if (codeList[0]) {
                this.form.categoryValue1 = codeList[0]
                this.getCategory(1, null)
              }
              if (codeList[1]) {
                this.form.categoryValue2 = codeList[1]
                this.getCategory(2, null)
              }
              if (codeList[2]) {
                this.form.categoryValue = codeList[2]
                this.getCategory(3, null)
              }
            } else {
              if (codeList[0]) {
                this.form.categoryValue1 = codeList[0]
                this.getCategory(1, null)
              }
              if (codeList[1]) {
                this.form.categoryValue2 = codeList[1]
                this.getCategory(2, null)
              }
            }

            if (this.form.gs1Code.includes("2")) {
              this.rules1.gs1Code = [{ required: true, message: 'GS1产品编码不能为空!' }]
            }
            if (!this.form.isSterilization) {
              this.rules2.sterilizationMethod = [{ required: false, message: '' }]
            }
            this.confirmLoading = false

          } else {
            this.$message.error(res.data || res.msg)
            this.confirmLoading = false
          }
        } else {
          const holdData = localStorage.getItem('holdData')
          if ( !holdData ) {
            // 获取分类列表
            this.getCategory(1)
            this.getzhucelist()
            let obj = {
              // categoryValue: '', //最小销售单元产品标识
              codeSystem: ['1'], //产品标识体系编码名称
              releaseTime: '', //发布时间
              minSaleNumber: '1', //最小销售单元中使用的数量
              gs1Code: '', //GS1产品编码
              isSameIdentification: true, //是否与最小销售单元产品标识一致
              isSameRegistered: true, //是否与注册/备案产品标识一致
              isHaveBody: false, //是否有本体标识
              identificationCarrier: ['2'], //标识载体
              specialConditions: '', //特殊储存或操作条件
              specialSize: '', //特殊尺寸说明
              productName: '', //产品名称/通用名称
              goodsName: '', //商品名称
              specificationModel: '', //规格型号
              isPackage: true, //器械是否为包类产品
              productDetails: '', //产品描述
              productNo: '', //品类编码
              originalCode: '', //原器械目录代码
              deviceCategory: 1, //器械类别
              mrSafetyInfo: '', //磁共振(MR)安全相关信息
              productType: 0, //产品类别
              maxReuseNumber: '', //最大重复使用次数
              isDisposable: true, //是否标记为一次性使用
              isSterilization: true, //使用前是否需要灭菌
              sterilizationMethod: '', //灭菌方式
              isAseptic: true, //是否为无菌包装
              otherUrl: '', //其它信息的网址链接
              registerNameEn: '', //医疗器械注册人/备案人英文名称
              registerName: '', //医疗器械注册人/备案人名称
              medicalCode: '', //医保编码
              registerNo: undefined, //注册证编号/备案凭证编号
              categoryCode: '',
              categoryValue1: '',
              categoryValue2: '',
              categoryValue: '',
              packageSpecification: 0, //写死
              isBatchNumber: true, //含批号
              isSerialNumber: true, //序列号
              isStartDate: true, //生产日期
              isEndDate: true, //失效日期
              productStoreList: [{ storeConditions: '', minValue: '', maxValue: '', unit: '', isdel: false }], //储存或操作信息
              productSizesList: [{ sizeType: '', sizeValue: '', unit: '', isdel: false }], //临床使用尺寸信息
            }
            this.form = obj

          }
        }
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.resetFields()
      this.page = 1
    },
    prev() {
      this.current--;
    },
    next() {

      this.$refs[this.current == 0 ? 'form1' : 'form2'].validate(async (success) => {
        console.log('===>>>',(this.current == 0 ? 'form1' : 'form2'),success)
          if (success === true) {
            this.current++;
          }else{
            this.$message.error('表单验证失败，请检查您的输入！')
          }
      })

    },
    handleOk() {
      const that = this
      console.log(that.form, '表单---')
      that.$refs['form3'].validate(async (success) => {
        console.log(success, 'success')
        if (success === true) {
          console.log('校验过了')
          let params = this.form
          params.productStoreList = this.form.productStoreList
          params.productSizesList = this.form.productSizesList
          // params.productDi = 'F6EC3B556E1B4A019AD4BC14BC15D2F5'
          params.unitId = this.$store.getters.userInfo.id
          if (this.form.categoryValue) {
            params.categoryCode =
              this.form.categoryValue1 + '-' + this.form.categoryValue2 + '-' + this.form.categoryValue
          } else {
            params.categoryCode = this.form.categoryValue1 + '-' + this.form.categoryValue2
            params.categoryValue = this.form.categoryValue2
          }
          console.log(params, 'params-----')
          // return
          if (this.form.id) {
            const res = await updateProductDi(params)
            console.log(res, 'res---')
            if (res.errno == 200 && res.errmsg === '成功') {
              this.$message.success('修改成功')
              this.close()
            } else {
              this.$message.error(res.errmsg)
            }
          } else {
            const res = await createProductDi(params)
            console.log(res, 'res---')
            if (res.errno == 200 && res.errmsg === '成功') {
              this.$message.success('注册成功')
              this.close()
            } else {
              this.$message.error(res.errmsg)
            }
          }
        } else {
          this.$message.error('表单验证失败，请检查您的输入！')
        }
      })
    },
    handleCancel() {
      localStorage.removeItem('holdData')

      this.close()
    },
    validateSupplierName(rule, value, callback) {
      let params = {
        name: value,
        type: '客户',
        id: this.model.id ? this.model.id : 0,
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    },
    hold(form) {
      let newHoldData = JSON.stringify(form) // 序列化对象
      localStorage.setItem('holdData', newHoldData)
      this.close()
    }
  },
}
</script>
<style scoped>
.title-box {
  width: 100%;
  display: flex;
  align-content: center;
  margin-bottom: 20px;
}
.btn {
  margin-left: 1200px;
}
.title {
  /* /* margin-left: 30px; */
  font-size: 24px;
  font-weight: 700;
}


/* 分页 */
.page {
  position: fixed;
  bottom: 10%;
  right: 40%;
}

/* 暂存 - 按钮 */
.hold {
  position: fixed;
  bottom: 10%;
  right: 32%;
}
</style>